import {OnboardingText1} from './OnboardingText1'
import {OnboardingText2} from './OnboardingText2'
import {OnboardingText3} from './OnboardingText3'
import {OnboardingText4} from './OnboardingText4'
import {OnboardingText5} from './OnboardingText5'
import {OnboardingText6} from './OnboardingText6'
import {OnboardingText7} from './OnboardingText7'
import {OnboardingText8} from './OnboardingText8'
import {OnboardingText9} from './OnboardingText9'

export const texts = [
    <OnboardingText1/>,
    <OnboardingText2/>,
    <OnboardingText3/>,
    <OnboardingText4/>,
    <OnboardingText5/>,
    <OnboardingText6/>,
    <OnboardingText7/>,
    <OnboardingText8/>,
    <OnboardingText9/>,
]